import { TabsType } from 'components/Tabs/Tabs';
import { Translation } from 'hooks/useTranslation/useTranslation';

const isCardsEnabled = process.env.REACT_APP_IS_CARDS_ENABLED === 'true';

export const createHardwareTabs = (translation: Translation): TabsType[] => [
  {
    text: translation.devices,
    location: '/hardware/locks'
  },
  ...(isCardsEnabled
    ? [
        {
          text: translation.access_cards,
          location: '/hardware/cards'
        }
      ]
    : [])
];
